import React, { useContext, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
import { LanguagesContext } from '../../context/LanguagesContext'
//import { Navbar, Nav } from 'react-bootstrap';
import { DropDown } from "./Dropdown";
import { Button } from 'react-bootstrap';

import './NavbarMenu.css';
import { Roles } from '../../hooks/auth.hook';

export const NavbarMenu = () => {

    const history = useHistory()
    const location = useLocation();
    const auth = useContext(AuthContext)
    const { pageLanguage, activeLanguage, changePageLanguage } = useContext(LanguagesContext);

    const logoutHandler = event => {
        event.preventDefault()
        auth.logout()
        history.push('/')
    }

    useEffect(() => {
        // console.log("NavBar init: " , pageLanguage, activeLanguage);

    });

    //console.log('role at nav', auth.role);
    //console.log('context', auth);


    return (
        <div className="header-wrapper">
            <header className="header">
                <div className="logo-place">
                    <img className="header-logo" alt="" src="/img/OthrReality.png" />
                </div>
                <div className="navigation">
                    {auth.role === Roles.Admin ?
                        [
                            <button className="header-navigation-button" key='lessons'>
                                <a href="/lessons" className={"header-navigation-link"
                                    + (location.pathname.includes('/lessons') ? " currentSection" : "")}>
                                    Lessons
                                </a>
                            </button>,
                            <button className="header-navigation-button" key='experiences'>
                                <a href="/experiences" className={"header-navigation-link"
                                    + (location.pathname.includes('/experiences') ? " currentSection" : "")}>
                                    Experiences
                                </a>
                            </button>]
                        : null
                    }
                    {auth.role === Roles.Admin || auth.role === Roles.Moderator ?
                        <button className={"header-navigation-button"
                            + (location.pathname.includes('/client') ? " currentSection" : "")}>
                            <a href={auth.role === Roles.Admin ? "/clients" : "/clients"}
                                className="header-navigation-link">
                                {auth.role === Roles.Admin ? "Clients" : "Content"}
                            </a>
                        </button>
                        : null
                    }
                    {auth.role === Roles.Admin || auth.role === Roles.Moderator || auth.role === Roles.Officer ?
                        <button className={"header-navigation-button"
                            + (location.pathname.includes('/users') ? " currentSection" : "")}>
                            <a href='/users'
                                className="header-navigation-link">
                                Users
                            </a>
                        </button>
                        : null
                    }
                    <button className={"header-navigation-button"
                        + (location.pathname.includes('/data') ? " currentSection" : "")}>
                        <a href="/data" className="header-navigation-link">
                            Data
                        </a>
                    </button>

                    {auth.role === Roles.Admin ?
                        <button className={"header-navigation-button"
                            + (location.pathname.includes('/settings') ? " currentSection" : "")}>
                            <a href="/settings" className="header-navigation-link" >
                                Settings
                            </a>
                        </button>
                        : null
                    }

                </div>
                <div className=" d-flex align-content-end">
                    {
                        ['/lessons', '/experiences'].includes(location.pathname) ?
                            (<div>
                                <DropDown list={activeLanguage} current={pageLanguage} change={changePageLanguage} />
                            </div>) : <div> </div>
                    }

                    <Button className={"ml-3 " + (location.pathname.includes('/content') ? "pt-3" : "pt-2")} variant="link" onClick={logoutHandler}>
                        <img className="logoutIcon" alt="" src="/img/logout.png" />
                    </Button>
                </div>
            </header>
        </div>
    );




}
